export const HYPERLINK_CLASS = " !text-Primary_Default";
